<template>
  <div class="payMentData">
    <div class="headerTitle">
      <div class="headerDescribe">
        <img class="payDataImg" src='~common/image/payPersent.png'>
        <span class="titleSpan">支付方式占比数据</span>
      </div>
      <data-header @select-resturantId ='changeResturantId'></data-header>
    </div>
    <!-- <div class="payMentHeader">
      <div class="returnBack"  @click="returnBackFn">
        <img class="searchImg" src="~common/image/returnBack.png" alt="">
        <span>返回</span>
      </div>
      <div class="payMentTitle">
        <span>{{getStatisticalDate | capitalize}}支付方式数据</span>
      </div>
     
    </div> -->
    <div id="payDateSelect"><date-select @select-date = 'getSelectDate' :dataTimeMenu='dayMenu'></date-select></div> 
    <div class="echartDiv">
        <div id="payChart" >          
        </div>
    </div>
    <div class="payDataList">
      <div class="dataListTitle" :class="fixedState == true ? 'dataListTitleFix':''">
          <span class="payStyleTitle">支付方式</span>
          <span class="aline"></span>
          <span class="payAmoutTitle">支付金额</span>
          <span class="aline"></span>
          <span class="payPerSentTitle">支付占比</span>
      </div>
      <div class="scrollList">
        <ul
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10">
          <li v-for="(item,index) in payMentListData" class="itemLi" :key="index">
            <span class="payStyleItem overHidden" v-if="item.payType === null">其他</span>
            <span class="payStyleItem overHidden" v-else>{{ item.payType }}</span>
            <span class="payAmoutItem overHidden">{{ item.payMoney }}</span>
            <span class="payPerSentItem overHidden">{{ item.payProportion }}%</span>           
          </li>
        </ul>
         <div class="updateTime2">
          <span>（数据更新时间：</span><span>{{this.updateTime | capitalize}}）</span>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import DataHeader from 'components/dataHeader'
import DateSelect from 'components/dateSelect'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      scroll: '',
      offsetHeight: 0,
      fixedState: false,
      payMentData: {},
      payMentListData: {},
      startDate: '',
      endDate: '',
      pieData: [],
      updateTime: '',
      dayMenu: [{ 'name': '今日数据' }, { 'name': '昨日数据' }, { 'name': '自定义' }],
      list: [
        {
          'payType': '微信支付',
          'payMoney': 500,
          'payProportion': 15
        },
        {
          'payType': '支付宝支付',
          'payMoney': 800,
          'payProportion': 35
        },
        {
          'payType': '好哒支付',
          'payMoney': 300,
          'payProportion': 20
        }
      ]
    }
  },
  components: {
    DataHeader,
    DateSelect
  },
  mounted() {
    // this.getOffsetHight() // 获取初始化的滚动高度
    // window.addEventListener('scroll', this.scrollTo) // 滚动事件监听
    this.todayOrYesday()
  },
  // destoryed() {
  //   window.removeEventListener('scroll', this.scrollTo)
  //   this.getOffsetHight()
  // },
  computed: {
    getStatisticalDate: function() {
      return this.$store.state.statisticalDate
    },
    getResturantId: function() {
      return this.$store.state.resturantId
    }
  },
  methods: {
    todayOrYesday() {
      if (this.common.localGet('dayFlag') === 1) {  // 昨日数据
        this.startDate = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
        this.endDate = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
      } else if (this.common.localGet('dayFlag') === 0) { // 今日数据
        this.startDate = this.common.formatDate(new Date())
        this.endDate = this.common.formatDate(new Date())
      }
      this.getPayData(this.startDate, this.endDate)  // 数据请求
    },
    drawLine(data, pieColor, pieTitle, hoverState, ifShowTip, ifLabelLine) {  // 数据、饼状图颜色、饼状图内部title、饼状图hover效果、是否显示悬浮提示框
     // 按需引入 ECharts 主模块
      const echarts = require('echarts/lib/echarts')
    // 引入饼状图
      require('echarts/lib/chart/pie')
      require('echarts/lib/component/tooltip')
      require('echarts/lib/component/title')
      // 基于准备好的dom，初始化echarts实例
      var mainChart = echarts.init(document.getElementById('payChart'))

      mainChart.setOption({
        title: pieTitle,
        tooltip: {
          show: ifShowTip,
          trigger: 'item',
          formatter: '{b}:<br/> {c} ({d}%)'
        },
        series: [
          {
            name: '',
            type: 'pie',
            hoverAnimation: hoverState,
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                label: {
                  show: ifLabelLine
                },
                labelLine: {
                  show: ifLabelLine
                }
              },
              emphasis: {
                label: {
                  show: ifLabelLine,
                  position: 'center',
                  textStyle: {
                    fontSize: '16',
                    fontWeight: 'bold'
                  }
                }
              }
            },
            data: data,
            minAngle: 18  // 可点击的最小范围
          }
        ],
        // grid: { top: 20, left: 0, right: 0, bottom: 0 },
        // color: ['#f74d47', '#ff7c4f', '#ffc955', '#d4ba8d', '#f8e9a5', '#e2006a', '#ffac8f', '#ff660a', '#ff8da0', '#ffe3bb', '#197d3a', '#87b40d', '#6cd15b', '#53b3cf', '#2fc3b0', '#b4580d', '#ffe400', '#ffa200', '#45f1f7', '#98f745']
        color: pieColor
      })
    },
    returnBackFn() {
      this.$router.push({ path: 'dataDisplay/businessData' }) // 跳转到登录页
    },
    // getOffsetHight() {
    //   this.offsetHeight = document.querySelector('.dataListTitle').offsetTop
    // },
    // scrollTo() {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   if (document.querySelector('.dataListTitle')) {
    //     var offsetTop = document.querySelector('.dataListTitle').offsetTop
    //   }
    //   if (scrollTop > offsetTop) {
    //     this.fixedState = true  // 标题浮动
    //   }
    //   if (scrollTop < this.offsetHeight) {
    //     this.fixedState = false  // 标题不浮动
    //   }
    // },
    getPayData(start, end) {
      const _this = this
      this.pieData = []
      this.$http.get(this.common.url_order + '/queryOrderPayDetails', {
        params: {
          restaurantId: _this.getResturantId,
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId'),
          startTime: start,
          endTime: end
        }
      })
      .then(function(response) {
        console.log(JSON.stringify(response))
        if (response.data.code === 0) {
          // _this.payMentListData = response.data.data.payList  // 列表数据
          _this.updateTime = response.data.data.serviceTime
          var payListData = response.data.data.payList
          for (let i = 0; i < payListData.length; i++) {
            payListData[i].payMoney = payListData[i].payMoney.toFixed(2)  // 金额保留两位小数
          }
          _this.payMentListData = payListData // 列表数据
          _this.payMentData = response.data.data.payModelList      // 饼图数据
          if (response.data.data.payModelList.length === 0) {
            _this.pieData.push({ 'name': '', 'value': 0 })
            var pieColorOne = ['#cccccc']
            var hoverStateOne = false
            var ifShowTipOne = false
            var ifLabelLineOne = false
            var pieTitleOne = {
              text: '暂无数据',
              subtext: '',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 18,
                color: '#cccccc'
              }
            }
            _this.drawLine(_this.pieData, pieColorOne, pieTitleOne, hoverStateOne, ifShowTipOne, ifLabelLineOne) // 请求数据成功后，渲染图表
          } else {
            // var pieColorTwo = ['#f74d47', '#ff7c4f', '#ffc955', '#d4ba8d', '#f8e9a5', '#e2006a', '#ffac8f', '#ff660a', '#ff8da0', '#ffe3bb', '#197d3a', '#87b40d', '#6cd15b', '#53b3cf', '#2fc3b0', '#b4580d', '#ffe400', '#ffa200', '#45f1f7', '#98f745']
            var pieColorTwo = ['#f74c46', '#ffc954', '#67cc48', '#36a9e5', '#b655e8', '#f17b3b', '#f75ca1', '#c0dc3c', '#3f77c2']
            var pieTitleTwo = {
              text: '总金额(元)',
              subtext: response.data.data.allProportion,
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 20,
                color: '#f74d47'
              },
              subtextStyle: {
                fontSize: 20,
                color: '#f74d47'
              }
            }
            var hoverStateTwo = true
            var ifShowTipTwo = true
            var ifLabelLineTwo = true
            for (var i = 0; i < response.data.data.payModelList.length; i++) {
              var name = response.data.data.payModelList[i].payType
              var value = response.data.data.payModelList[i].payMoney
              _this.pieData.push({ 'name': name, 'value': value })
            }
            _this.drawLine(_this.pieData, pieColorTwo, pieTitleTwo, hoverStateTwo, ifShowTipTwo, ifLabelLineTwo) // 请求数据成功后，渲染图表
          }
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    getSelectDate(date) {
      this.startDate = date[0]
      this.endDate = date[1]
      this.getPayData(this.startDate, this.endDate)
    },
    changeResturantId() {
      this.getPayData(this.startDate, this.endDate)
    }
  }
}
</script>
<style>
  .headerTitle{
    position:fixed;
    top:0;
    left:0;
    z-index: 9;
    width:100%;
    height: 0.9rem;
    line-height: 0.9rem;
    display:flex;
    display: -webkit-flex; 
    justify-content: space-between;
    align-items:center;
    background-color: #ffffff; 
    -moz-box-shadow:0px 6px 0px rgba(171,175,177,.40); -webkit-box-shadow:0px 6px 0px rgba(171,175,177,.40); box-shadow:0px 6px 0px rgba(171,175,177,.40);
  }
  .headerDescribe{
    display:flex;
    display: -webkit-flex; 
    align-items:center;
    margin-left: 0.2rem;
  }
  .titleSpan{
    font-size: 0.28rem;
    font-weight: 600;
    color:#000000;
  }
  .payDataImg{
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.1rem;
  }
  #payDateSelect{
    /* position: fixed;
    top: 1rem; */
    width: 100%;
    background-color: #ffffff;
  }
  #payDateSelect .dateComponent .dataSelect .dayBtn{
    background-color: #fff;
    color: #f74d47;
    border: 1px solid #f74d47;
  }
  #payDateSelect .dateComponent .dataSelect .dayActive{
    background-color: #f74d47;
    color: #ffffff;
    border: 1px solid #f74d47;
  }
  #payChart{
    width: 100%;
    height: 100%;
  }
  .payTitleDiv{
    height: 10%;
    display:flex;
    display: -webkit-flex; 
    align-items:center;
    justify-content:center;
  }
  .payTitle{
    font-size: 0.28rem;
    color: #000000;
    font-weight: 700
  }
  .payMentData{
    height: 100%;
    width: 100%;
    background-color: #f1f2f3;
    padding-top: 1rem;
  }
  .payMentHeader{
    width: 100%;
    height: 0.9rem;
    background-color: #ffffff;
    -moz-box-shadow:0px 6px 10px rgba(171,175,177,.40); -webkit-box-shadow:0px 6px 10px rgba(171,175,177,.40); box-shadow:0px 6px 10px rgba(171,175,177,.40);
  }
  .returnBack{
    width: 1.4rem;
    height: 0.9rem;
    line-height: 0.9rem;
    float: left;
    text-align: center;
    
  }
  .returnBack span{
    color: #f74d47;
    font-size: 0.28rem;
  }
  .payMentTitle{
    width: 4rem;
    height: 0.9rem;
    line-height: 0.9rem;
    margin:0 auto;
    text-align: center;
    display: block;
  }
  .payMentTitle span{
    font-size: 0.28rem;
    color: #f74d47
  }
   .searchImg{
    vertical-align: middle;
    width: 9px;
    height: 18px;
    margin-bottom: 0.06rem;
  }
  .echartDiv{
    width: 100%;
    height:5rem;
    background-color: #ffffff;
    -moz-box-shadow:0px 6px 10px rgba(171,175,177,.40); -webkit-box-shadow:0px 6px 10px rgba(171,175,177,.40); box-shadow:0px 6px 10px rgba(171,175,177,.40);
  }
  .payDataList{
    margin-top: 0.1rem;
    width: 100%;
    /* height: 46%; */
    background-color: #ffffff
  }
  .dataListTitle{
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #f3fbfd;
  }

  .payStyleTitle,.payAmoutTitle,.payPerSentTitle{
    width: 33%;
    display: inline-block;
    float: left;
    text-align: center;
    height: 0.6rem;
    line-height: 0.6rem;
  }
  .aline{
    float: left;
    border-right: 1px solid #ccc;
    width: 0.01rem;
    height: 0.3rem;
    margin-top: 0.15rem;
  } 
 
  .dataListTitleFix{
    position:fixed;
    top: 0
  }
  .itemLi{
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
  }

  .payAmoutItem,.payStyleItem{
    float: left;
    text-align: center;
    width: 33.3%;
    display: inline-block;
  }
  .payPerSentItem{
    float: left;
    text-align: center;
    width: 33.3%;
    display: inline-block;
  }

  .scrollList{
    background-color: #ffffff
  }
  .itemLi:not(:last-child){
    border-bottom: 1px solid #f0f0f0
  }
  .overHidden{
    overflow:hidden;/*内容超出后隐藏*/
    text-overflow: ellipsis;/*超出内容后显示为省略号*/
    white-space: nowrap/*文本不换行*/
  }
  .updateTime2{
    width: 100%;
    height: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f1f2f3;
  }
  .updateTime2 span{
    font-size: 0.24rem;
    color:#000000;
  } 

</style>



// WEBPACK FOOTER //
// src/components/payMentData.vue